import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { SimulationConfig } from '@/types';

interface SimulationFooterProps {
  config: SimulationConfig;
  currentRgb: string;
}

export const SimulationFooter: React.FC<SimulationFooterProps> = ({ config, currentRgb }) => {
  if (!config.footerText) return null;
  
  return (
    <div className="absolute left-1/2 -translate-x-1/2 bottom-28 pointer-events-none text-center z-10 w-full px-4">
      <AnimatePresence mode="wait">
        <motion.p 
          key={config.footerText}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="uppercase tracking-[0.1em] transition-all duration-300" 
          style={{ 
            color: config.rgbLighting ? currentRgb : config.footerTextColor,
            fontSize: `${config.footerFontSize}px`,
            fontFamily: config.footerFontFamily,
            fontWeight: config.footerFontWeight
          }}
        >
          {config.footerText}
        </motion.p>
      </AnimatePresence>
    </div>
  );
};
